import { createContext, useContext } from "react";

export const ConfigContext = createContext({});

/** Temporarily changed to any to support passing functions through */
export const useConfig = (): Record<string, any> => {
	const envData = useContext(ConfigContext);
	return envData;
};

export const ConfigProvider = ({ children, ...props }) => {
	const envData = useConfig();
	return (
		<ConfigContext.Provider value={{ ...envData, ...props }}>
			{children}
		</ConfigContext.Provider>
	);
};
